<template>
  <div class="content contentBody">
    <div class="content-tab-box">
      <span :class="meaulistTab.firstTab==item?'content-tab-box-active':''" @click="tabCurrentFn(item)"
            v-for="(item,index) in meaulistTab.tab" :key="index">{{index}}</span>
    </div>
    <div v-for="item in meaulistTab.tab" :key="item">
      <component v-bind:is="item" v-if="meaulistTab.firstTab==item"></component>
    </div>
  </div>
</template>
<script>
  import purchaselog from "./purchaselog.vue";
  import drawLog from "./drawLog.vue";
  import participationlog from "./participationlog.vue";
  import sharelogin from "./sharelogin.vue";
  import dyLog from "./dyLog.vue";
  let tabBox = {
    '购买日志': {property: 'purchaselog'},
    '访问日志': {property: 'participationlog'},
    '分享日志': {property: 'sharelogin'},
    '抽奖日志': {property: 'drawLog'},
    '抖音日志': {property: 'dyLog'}
  }
  export default {
    name: "tkJournal",
    components: {
      purchaselog,
      drawLog,
      participationlog,
      sharelogin,
      dyLog
    },
    data() {
      return {
        activeName: "",
        meaulistTab: this.meaulist.meaulistGet(this, tabBox)
      };
    },
    created() {
      if (this.$route.query.tab) {
        this.tabCurrentFn(this.$route.query.tab)
      } else {
        this.inittab();
      }
    },
    methods: {
      inittab() {
        this.activeName =
            this.$route.query.tab !== undefined
                ? this.$route.query.tab
                : "purchaselog";
      },
      tabCurrentFn(index) {
        this.meaulistTab.firstTab = index
      }
    }
  };
</script>
